const TABS = [
  { key: "compose", label: "Compose" },
  { key: "received", label: "Received" },
  { key: "sent", label: "Sent" },
];

const NotificationsTabs = ({ tab, onChange, unreadCount = 0, showSent = true }) => (
  <div className="flex gap-1 border-b border-gray-200 mt-4 mb-6">
    {TABS.filter((t) => showSent || t.key !== "sent").map((t) => (
      <button
        key={t.key}
        type="button"
        onClick={() => onChange(t.key)}
        className={`inline-flex items-center gap-2 px-4 py-2 text-sm font-semibold border-b-2 -mb-px transition-colors ${
          tab === t.key
            ? "border-primary text-primary_dark"
            : "border-transparent text-gray-400 hover:text-secondary"
        }`}
      >
        {t.label}
        {t.key === "received" && unreadCount > 0 && (
          <span
            className={`inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full text-[10px] font-bold ${
              tab === "received"
                ? "bg-primary text-white"
                : "bg-gray-200 text-gray-500"
            }`}
          >
            {unreadCount}
          </span>
        )}
      </button>
    ))}
  </div>
);

export default NotificationsTabs;
